import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ApiOfflineBanner from './components/ApiOfflineBanner';
import Home from './pages/Home';
import Guias from './pages/Guias';
import Guia from './pages/Guia';
import NotFound from './pages/NotFound';
import Golpe from './pages/Golpe';
import ScrollToTop from './components/ScrollToTop';
import { CanonicalUrl } from './utils/seo';
import News from './pages/News';
import AdminPanel from './pages/AdminPanel';
import AdminNews from './pages/AdminNews';
import Contact from './pages/Contact';
import AdminUsers from './pages/AdminUsers';
import AdminSettings from './pages/AdminSettings';
import AdminMessages from './pages/AdminMessages';
import Login from './pages/Login';
import TermsOfUse from './pages/TermsOfUse';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Account from './pages/Account';
import './App.css';

function App() {
  const backgroundStyle = {
    backgroundImage: `url('/fundo site.webp?v=2')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed'
  };

  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <CanonicalUrl />
        <div className="App" style={backgroundStyle}>
          <ApiOfflineBanner />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/guias" element={<Guias />} />
            <Route path="/guias/:slug" element={<Guia />} />
            <Route path="/golpe-do-falso-advogado" element={<Golpe />} />
            <Route path="/noticias/:id" element={<News />} />
            <Route path="/noticias" element={<News />} />
            <Route path="/contato" element={<Contact />} />
            <Route path="/admin" element={<Login />} />
            <Route path="/admin/painel" element={<AdminPanel />} />
            <Route path="/admin/noticias" element={<AdminNews />} />
            <Route path="/admin/usuarios" element={<AdminUsers />} />
            <Route path="/admin/configuracoes" element={<AdminSettings />} />
            <Route path="/admin/mensagens" element={<AdminMessages />} />
            <Route path="/cadastro" element={<Navigate to="/admin" replace />} />
            <Route path="/esqueci-senha" element={<Navigate to="/admin" replace />} />
            <Route path="/redefinir-senha" element={<Navigate to="/admin" replace />} />
            <Route path="/termos-de-uso" element={<TermsOfUse />} />
            <Route path="/politica-privacidade" element={<PrivacyPolicy />} />
            <Route path="/conta" element={<Account />} />
            <Route path="/verify-email" element={<Navigate to="/admin" replace />} />
            <Route path="/confirm-email-change" element={<Navigate to="/admin" replace />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;

